import styled from "styled-components";

const NotfoundWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 204px;

  h1 {
    font-size: 102px;
    font-weight: 800;
    margin: 0;
  }

  p {
    font-size: 20px;
    font-weight: 700;
    color: #656565;
    font-style: italic;
  }
`

export default NotfoundWrap
